module.exports = __webpack_public_path__ + "media/buy-now/sample_box5-452b1e65.png";